<template>
    <div>
        <div class="title">
            <h3 class="left">Générales</h3>
            <button class="btn btn-default btn-sm" @click="$emit('edit')">Modifier</button>
        </div>
        <div class="general-lists">
            <div class="table-responsive">
                <div id="basicTable_wrapper" class="dataTables_wrapper form-inline no-footer">
                    <table class="table table-hover dataTable no-footer" id="basicTable" role="grid" :key="customer.id">
                        <tbody>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Forme juridique</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.decoded_legal_form}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Nom de l'entreprise</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.name}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.initials">
                                <td class="v-align-middle">
                                    <span>Sigle</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.initials}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.trade_name">
                                <td class="v-align-middle">
                                    <span>Nom commercial</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.trade_name}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Entité</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customerEntity}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Vigilance</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>
                                        <i v-if="showVigilance" class="circle" :class="[vigilanceStatusClass]"></i>
                                        {{customer.decoded_vigilance_status}}
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="customer.decoded_status">
                                <td class="v-align-middle">
                                    <span>Status</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.decoded_status}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.recovery_level > 0">
                                <td class="v-align-middle">
                                    <span>Niveau de relance</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{ customer.recovery_level }}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.last_recovery_date">
                                <td class="v-align-middle">
                                    <span>Date de dernière relance</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{ customer.last_recovery_date | moment-date }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Activité</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.activity}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.naf">
                                <td class="v-align-middle">
                                    <span>Code NAF</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.naf}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>SIREN</span>
                                </td>
                                <td class="v-align-middle">
                                    <span v-if="customer.siren">{{customer.siren}}</span>
                                    <span v-else>Non renseigné</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" class="v-align-middle" style="font-style: italic;">
                                    Dernière mise à jour : 

                                    <span v-if="lastSirenUpdate">
                                        <span>le {{ lastSirenUpdate.created_at | moment-date }}</span>
                                        <span v-if="lastSirenUpdate.user">par {{ lastSirenUpdate.user.email }}</span>
                                        <span v-else>par Utilisateur supprimé</span>
                                    </span>

                                    <span v-else class="text-danger">Jamais</span>
                                </td>
                            </tr>
                            <tr v-if="customer.siret">
                                <td class="v-align-middle">
                                    <span>SIRET</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.siret}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.tva_intra">
                                <td class="v-align-middle">
                                    <span>TVA intracom.</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.tva_intra}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span>Facture électronique</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.electronic_invoice ? "oui" : "non"}}</span>
                                </td>
                            </tr>
                            <tr v-if="customer.decoded_origin">
                                <td class="v-align-middle">
                                    <span>Origine</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.decoded_origin}}</span>
                                </td>
                            </tr>
                            <tr v-if="brands.length">
                                <td class="v-align-middle">
                                    <span>Marques</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{decodeBrands(brands).join(", ")}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span># SAP</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.erp_id}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="v-align-middle">
                                    <span># Dom2004</span>
                                </td>
                                <td class="v-align-middle">
                                    <span>{{customer.sap_busort}}</span>
                                </td>
                            </tr>
                            <tr v-if="sapOrganizations.length > 0">
                                <td>
                                    <span>Moyen de paiement</span>
                                </td>
                                <td>
                                    <ul>
                                        <li v-for="(sapOrganization, index) in sapOrganizations" :key="index">
                                            <span><b>{{ sapOrganization.organization.display_name}}</b> :
                                                {{ paymentMethodDisplayedText(sapOrganization.payment_method) }}</span>
                                        </li>
                                    </ul>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <span v-if="customer.buyers.length > 1">Utilisateurs
                                        <br>associés
                                    </span>
                                    <span v-else :class="customer.buyers.length < 1 ? 'text-danger' : ''">Utilisateur
                                        <br>associé
                                    </span>
                                </td>
                                <td>
                                    <ul v-if="customer.buyers.length > 0">
                                        <li v-for="(buyer, index) in customer.buyers" :key="index">
                                            <a :href="'mailto:' + buyer.email" target="_blank">{{ buyer.email }}</a>
                                            <i
                                                v-if="isDefaultBuyer(buyer)"
                                                class="fa fa-lg fa-envelope text-primary"
                                                style="margin-left: 5px;"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Destinataire des notifications mail."
                                            ></i>
                                            <i
                                                v-if="buyer.email_suppressed"
                                                class="fa fa-lg fa-exclamation-triangle text-warning"
                                                style="margin-left: 5px;"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                title="Adresse email désactivée : aucun email ne lui sera envoyé."
                                            ></i>
                                            <i
                                                v-if="userIsLocked(buyer)"
                                                class="fa fa-lg fa-lock"
                                                style="margin-left: 5px;"
                                                data-toggle="tooltip"
                                                data-placement="top"
                                                :title="unlockedAtMessage(buyer)"
                                            ></i>
                                        </li>
                                    </ul>
                                    <ul v-else class="text-danger">
                                        <li>Aucun utilisateur associé</li>
                                    </ul>
                                    <button
                                        v-if="customer.buyers.length > 1"
                                        class="btn btn-default btn-xs"
                                        @click="editingDefaultBuyer = true"
                                    >
                                        Modifier le destinataire
                                    </button>
                                    <default-buyer-modal
                                        v-if="editingDefaultBuyer"
                                        :customer-id="customer.id"
                                        :buyers="customer.buyers"
                                        :current-buyer-id="customer.default_buyer ? customer.default_buyer.id : null"
                                        @close="closeDefaultBuyerModal"
                                    ></default-buyer-modal>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
span {
    position: relative;
}

.table {
    tbody {
        tr {
            td {
                padding: 5px;
                border: 0;

                &:first-child {
                    color: #AAA;
                }

                .circle {
                    top: 5px;
                    left: -20px;
                }
            }
        }
    }
}

</style>

<script type="text/babel">
import customerMixin from 'mixins/customer'
import DefaultBuyerModal from './DefaultBuyerModal'

export default {

    mixins: [customerMixin],

    components: { DefaultBuyerModal },

    data() {
        return {
            editingDefaultBuyer: false
        }
    },

    props: {
        customer: {
            type: Object,
            required: true
        },

        brands: {
            type: Array,
            required: true
        },

        sapOrganizations: {
            type: Array,
            required: true
        }
    },

    mounted() {
        $('[data-toggle="tooltip"]').tooltip()
    },

    methods: {
        paymentMethodDisplayedText(payment_method) {
            return payment_method != null ? payment_method.display_name : 'Non renseigné'
        },
        isDefaultBuyer(buyer) {
            return this.customer.default_buyer && this.customer.default_buyer.id === buyer.id
        },
        closeDefaultBuyerModal() {
            this.editingDefaultBuyer = false
            this.$nextTick(() => $('[data-toggle="tooltip"]').tooltip())
        },
        userIsLocked(user) {
            if (!user || !user.hasOwnProperty('unlocked_at') || !user.unlocked_at) {
                return false
            }

            const unlockedAt = moment(user.unlocked_at)

            return unlockedAt.isAfter(moment())
        },
        unlockedAtMessage(user) {
            if (!this.userIsLocked(user)) {
                return ''
            }
            
            return "Utilisateur bloqué jusqu\'au " + this.$options.filters['moment-french-datetime'](user.unlocked_at)
        }
    }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/General.vue